import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TableContext } from '../../contexts/tableContext';
import {
  getDefaultAdminHomePath,
  isPathAllowedForUser,
} from '../../utils/menuAccess';

function PermissionRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { userMenus, setPermissionDeniedOpen } = useContext(TableContext);
  const pathname = location.pathname;
  const allowed = isPathAllowedForUser(pathname, userMenus);
  const homePath = getDefaultAdminHomePath(userMenus);

  useEffect(() => {
    if (!allowed) {
      toast.dismiss();
      if (pathname !== homePath) {
        navigate(homePath, { replace: true });
      }
      setPermissionDeniedOpen(true);
    }
  }, [allowed, pathname, homePath, navigate, setPermissionDeniedOpen]);

  if (!allowed) {
    return null;
  }

  return children;
}

export default PermissionRoute;
